module.exports = __webpack_public_path__ + "img/Number=31.6e508fa2.png";